export * from './fetch';
export * from './deviceConfig';

export const stripHtml = (html: string) => html.replace(/<[^>]*>/g, '');
